import { Form, Select, Typography, Row, Col } from "antd";
import React from "react";
import {
  babinskisOptions,
  bodypartOptions,
  reflexes,
} from "../../../../Options/systemicExamOptions";

const selectProps = {
  showSearch: true,
  style: { width: "100%" },
  optionLabelProp: "label",
  // Keep dropdown aligned to the field and fully inside the viewport
  popupMatchSelectWidth: true,
  getPopupContainer: () => document.body,
  popupClassName: "reflex-select-dropdown",
  className: "reflex-select",
  listHeight: 280,
};

const ReflexesForm = () => {
  return (
    <div className="reflexes-form-surface">
      <Row gutter={[16, 16]}>
        {reflexes.map((reflex) => (
          <Col xs={24} md={12} key={reflex.value}>
            <div className="reflexes-form-item">
              <Typography className="reflexes-form-item__label">
                {reflex.label}
              </Typography>
              <Row gutter={[12, 12]}>
                {/* Stack Left/Right on phones so dropdown isn't squeezed */}
                <Col xs={24} md={12}>
                  <Form.Item
                    name={`${reflex.value}_left`}
                    label="Left"
                    style={{ marginBottom: 0 }}
                  >
                    <Select
                      {...selectProps}
                      options={
                        reflex.label === "Babinski's"
                          ? babinskisOptions
                          : bodypartOptions
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    name={`${reflex.value}_right`}
                    label="Right"
                    style={{ marginBottom: 0 }}
                  >
                    <Select
                      {...selectProps}
                      options={
                        reflex.label === "Babinski's"
                          ? babinskisOptions
                          : bodypartOptions
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ReflexesForm;
